import { KpkBasket, localStorageEffect } from "@keepeek/commons";
import { atom } from "recoil";

export const currentBasketIdState = atom<KpkBasket["id"] | undefined>({
  key: "CurrentBasketIdState",
  default: undefined,
  effects: [localStorageEffect(`CurrentBasketIdState`)],
});
